<template>
<div>
  <Header/>
  <div class="page_not_found">
    <v-container pa-0>
      <h1>{{$t('page_not_found')}}</h1>
    </v-container>
  </div>
</div>
</template>

<script>
import Header from '../components/global/Header.vue'

export default {
  name: 'PageNotFound',
  components: {
    Header
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/sass/global/variables";
  .page_not_found {
    width: 100%;
    height: calc(100vh - (100px + 90px));
    display: flex;
    align-items: center;
    margin-top: 100px;
    background-color: #edefef;
    @media screen and (max-width: $screen-sm) {
      margin-top: 50px;
      height: calc(100vh - (50px + 112px));
    }
    h1 {
      font-size: 36px;
      line-height: 40px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 20px;
      text-transform: capitalize;
      @media screen and (max-width: $screen-sm) {
        font-size: 26px;
        line-height: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/PageNotFound.vue